export const rows = [
  {
    id: 1,
    acc_description: 'Labor, Personnel Costs',
    priorY: ' 1.213.600',
    priorM: ' 1.592.850',
    actual: ' 1.517.000',
    rf_n: ' 1.638.360',
    parentId: null,
    type: 'step',

  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '01 Salaries and wages',
        priorY: '120.000',
        priorM: '157.500',
        actual: '150.000',
        rf_n: '162.000',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '02 Reversal of vacations provisions',
        priorY: '72.000',
        priorM: '72.500',
        actual: '90.000',
        rf_n: '97.200',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '05 Others Personnel Costs',
        priorY: '514.240',
        priorM: '674.940',
        actual: '642.800',
        rf_n: '694.224',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '08 Sales Comissions',
        priorY: '72.000',
        priorM: '94.500',
        actual: '90.000',
        rf_n: '97.200',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '09 Travel, entertain, and missions represantations',
        priorY: '8.000',
        priorM: '10.500',
        actual: '10.000',
        rf_n: '10.800',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '12 Insurance',
        priorY: '16.000',
        priorM: '21.500',
        actual: '20.000',
        rf_n: '21.000',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '17 Office costs and consumptions',
        priorY: '8.000',
        priorM: '10.500',
        actual: '10.000',
        rf_n: '10.800',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '20 Personnel Training and Seminars',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.000',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontracting',
        priorY: '112.000',
        priorM: '147.500',
        actual: '140.000',
        rf_n: '151.000',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '120.000',
        priorM: '157.500',
        actual: '150.000',
        rf_n: '162.000',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '34 Cost Allocation',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '46 Others Provisions',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '171.360',
        priorM: '224.910',
        actual: '214.200',
        rf_n: '231.336',
        type: 'row',
        parentId: 1,
      },

  {
    id: 2,
    acc_description: 'Travel & Entertainment',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '09 Travel, entertain, and missions represantations',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 2,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 2,
      },

  {
    id: 3,
    acc_description: 'Rental & lease',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '14 Lodging',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 3,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '15 Buildings, equipments and tools',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 3,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 3,
      },

  {
    id: 4,
    acc_description: 'Repair ¨& Maintenance, utilities',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '15 Buildings, equipments and tools',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '17 Office costs and consumptions',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 4,
      },

  {
    id: 5,
    acc_description: 'Promotion & Advertising',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '06 Promotion and advertising',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '08 Sales Comissions',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontractings',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '23 Warranty Costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 5,
      },

  {
    id: 6,
    acc_description: 'Depreciation & Amortization',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description: '25 Depreciation and amortization',
    priorY: '24.000',
    priorM: '31.500',
    actual: '30.000',
    rf_n: '32.400',
    type: 'row',
    parentId: 6,
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description: 'Without Classification',
    priorY: '24.000',
    priorM: '31.500',
    actual: '30.000',
    rf_n: '32.400',
    type: 'row',
    parentId: 6,
  },

  {
    id: 7,
    acc_description: 'IFRS 9 provision',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
    {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description: 'Without Classification',
    priorY: '24.000',
    priorM: '31.500',
    actual: '30.000',
    rf_n: '32.400',
    type: 'row',
    parentId: 7,
  },

  {
    id: 8,
    acc_description: 'Other provisions',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '18 Services Contracts (Security, Other 3rd Serv)',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '19 Taxes & related costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '23 Warranty Costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '25 Depreciation and amortization',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '44 Provisions for doubtful accounts',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '46 Others Provisions',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 8,
      },

  {
    id: 9,
    acc_description: 'External fees & related costs',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '11 External fees and related costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '19 Taxes & related costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontracting',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 9,
      },

  {
    id: 10,
    acc_description: 'Insurance',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '12 Insurance',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 10,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 10,
      },

  {
    id: 11,
    acc_description: 'Taxes & Related Costs',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '19 Taxes & related costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 11,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 11,
      },

  {
    id: 12,
    acc_description: 'Royalties paid',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description: 'Without Classification',
    priorY: '24.000',
    priorM: '31.500',
    actual: '30.000',
    rf_n: '32.400',
    type: 'row',
    parentId: 12,
  },

  {
    id: 13,
    acc_description: 'Other',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '03 Under/Over',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '06 Promotion and advertising',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '07 Freight on sales and related costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '08 Sales Comissions',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '09 Travel, entertain, and missions represantations',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '10 Telephone  / Mailling',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '11 External fees and related costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '14 Lodging',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '15 Buildings, equipments and tools',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '16 Water and Energy rates',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '17 Office costs and consumptions',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '18 Services Contracts (Security, Other 3rd Serv)',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontracting',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '22 Information Technology',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '23 Warranty Costs',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '34 Cost Allocation',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '44 Provisions for doubtful accounts',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '46 Others Provisions',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '24.000',
        priorM: '31.500',
        actual: '30.000',
        rf_n: '32.400',
        type: 'row',
        parentId: 13,
      },

  {
    id: 14,
    acc_description: 'Allocation Costs',
    priorY: '48.000',
    priorM: '63.000',
    actual: '60.000',
    rf_n: '64.800',
    parentId: null,
    type: 'step',
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description: 'Without Classification',
    priorY: '24.000',
    priorM: '31.500',
    actual: '30.000',
    rf_n: '32.400',
    type: 'row',
    parentId: 14,
  },

  {
    id: 99,
    acc_description: 'Total Geral',
    priorY: '2.758.400',
    priorM: '3.620.400',
    actual: '3.448.000',
    rf_n: '3.723.840',
    parentId: null,
    type: 'step',
  },
]

export const columns = [
  { name: 'acc_description', title: 'ACC DESCRIPTION' , editable : false},
  { name: 'priorY', title: 'PRIOR Y' },
  { name: 'priorM', title: 'PRIOR M' },
  { name: 'actual', title: 'ACTUAL' },
  { name: 'rf_n', title: 'RF N' },
];

export const headerInformation = {
  dateBetween: 'Jan 20 - Dec 20',
  Country: 'Brasil',
  FunctionalArea: '(P65500,P65700)',
  PersonResponsible: 'Camille Forestier',
  UserResponsible: 'SESA368320',
  CostCenter: 'BR016270'
}


